import React from "react";
import { Controller, useForm } from "react-hook-form";
import { DropdownList } from "react-widgets";
import { toastr } from "react-redux-toastr";
import { Customer } from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import api from "../../../../api";
import { useDataLoader } from "react-remote-data-hooks";
import { useSelector } from "react-redux";
import { State } from "../../../../core/store/interfaces";
import { useLead } from "../../../../core";

interface FormProps {
  name?: string;
}

const EditInfluencer: React.FunctionComponent<{
  error?: string;
  onClose: () => void;
  updateUser: (details: Customer) => void;
  customerDetails?: Customer;
  property: string;
  value?: string;
  title: string;
  loadData: () => Promise<any[]>;
}> = (props) => {
  const leadState = useSelector((state: State) => state.lead);
  const { updateLeadDetails } = useLead(api.lead);
  const { loadData } = props;
  const { data } = useDataLoader(() => loadData());

  const { control, handleSubmit, errors, watch } = useForm<FormProps>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const onSubmit = (updateData?: any) => {
    onUpdate(updateData.name);
  };

  const onUpdate = async (value: string) => {
    const updateData = {
      influenceId: value,
      userId: props.customerDetails?._id!,
    };

    try {
      await api.lead.updateUserInfluence(
        updateData,
        leadState?.leadDetails?._id
      );
      const response = await api.lead.getLead(leadState?.leadDetails?._id!);

      updateLeadDetails(response?.data);
      props.onClose();
      toastr.success("Success", `${props.title} updated successfully`);
    } catch (error) {
      if (error?.response?.data?.message) {
        toastr.error("Error", error?.response?.data?.message);
      }
    }
  };

  const onFieldUpdate = (e: { key: string }) => {
    if (e.key === "Enter") {
      onUpdate(watch("name") || "");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mt-2 d-flex flex-wrap px-4 py-2 border-top border-bottom contact-form-row active align-items-center">
        <div className="col px-2 contact-label font-xs text-gray-500">
          {props.title}
        </div>
        <div className="col px-2 contact-content d-flex align-items-center">
          <Controller
            control={control}
            rules={{
              required: true,
              validate: (value) => {
                return !!value.trim();
              },
            }}
            name={"name"}
            defaultValue={props.customerDetails?.influencer?.name}
            render={({ onChange, value, name }) => (
              <DropdownList
                value={value}
                defaultValue={value}
                data={data}
                textField={"name"}
                valueField={"_id"}
                placeholder={props.title}
                onChange={(val) => {
                  onChange(val._id);
                }}
              />
            )}
          />
          {errors.name && (
            <ErrorMessage>{props.title} is required</ErrorMessage>
          )}
        </div>

        <div className="col-12 px-2 mt-1 text-right">
          <button
            type="submit"
            className="btn btn-sm btn-outline-dark mr-2 font-normal"
            onClick={props.onClose}
          >
            Cancel
          </button>
          <button className="btn btn-sm btn-primary font-normal">Save</button>
        </div>
      </div>
    </form>
  );
};

export default EditInfluencer;
